import React, { Component } from 'react'
import { Table, Tooltip, Modal, Button, Form, Collapse, Input, Select } from 'antd'
import { connect } from 'dva'
import { Link } from 'dva/router'
import moment from 'moment'
import InfiniteScroll from '@fand/react-infinite-scroll-container';
import { all } from '../../services/restApi'
import config from '../../utils/config'
var Icon = require('react-fontawesome');
const _ = require('underscore')

const { Column } = Table;
const confirm = Modal.confirm
const ButtonGroup = Button.Group;
const Panel = Collapse.Panel;
const FormItem = Form.Item;
const Option = Select.Option;

class Client extends Component {

	constructor (props) {
		super(props);

		this.state = {
			hotels: []
		};

		if (localStorage.getItem('currentHotel') && JSON.parse(localStorage.getItem('currentHotel')).objectId) 
			this.state = {...this.state, currentHotel: JSON.parse(localStorage.getItem('currentHotel'))};
	}


	/**
    * Inicializa los valores, según si se está creando o editando un registro
    */
    componentDidMount () {

        let query = {};

        if (this.props.app.user.type === 'recepcionista' || this.props.app.user.type === 'gerente') {
            query.objectId = {$in: _.pluck(this.props.app.user.hotels, 'objectId')}
        }

        // Consulta los hoteles
        all('Hotel', {where: query, limit: 20}).then((resp) => {
            this.setState({
                hotels: resp.results
            });
        })
    }

    loadMore () {
    	if (this.props.client.skip < this.props.client.total_items) {

    		let query = {};

    		if (this.props.app.user.type === 'recepcionista' || this.props.app.user.type === 'gerente') {
				query.hotel = {$in: this.props.app.user.hotels};
			}

            if (this.state.currentHotel)
                query.hotel = {__type: 'Pointer', className: 'Hotel', objectId: this.state.currentHotel.objectId}

    		this.props.dispatch({type: 'client/query', payload: {
    			where: query,
				skip: this.props.client.skip,
				limit: this.props.client.limit,
				count: 1,
				order: '-createdAt'
	    	}});
    	}
    }

    delete_item (item) {

    	let dispatch = this.props.dispatch

    	confirm({
	    	title: '¿Estás seguro que deseas eliminar el cliente?',
	      	onOk () {
	        	dispatch({type: 'client/removeItem', payload: item});
	      	}
	    })
    }


    /**
    * Encuentra las coincidencias según la cadena del input Hotel
    */
    fetch (value, callback) {

        let query = { name: {$regex: '(?i)' + value} };

        if (this.props.app.user.type === 'recepcionista' || this.props.app.user.type === 'gerente') {
            query.objectId = {$in: _.pluck(this.props.app.user.hotels, 'objectId')}
        }

        setTimeout(() => {
            all('Hotel', {where: query}).then((d) => {
                const results = d.results;
                const hotels = [];
                
                results.forEach((r) => {
                    hotels.push({
                        objectId: r.objectId,
                        name: r.name,
                    });
                });

                callback(hotels);
            });
        }, 500);
    }


    /**
    * Asigna los nuevos valores traidos de la consulta de coincidencias
    */
    handleSelectHotelChange (value) {
        if (value && value.key && !value.label) {
            this.fetch(value.key, (resp) => {
                this.setState({ hotels: resp })
            });
        }
    }


    /**
    * Búsqueda
    */
    search (e) {
        e.preventDefault();

        this.props.form.validateFieldsAndScroll((errors, values) => {
            if (errors) { return }

            // Query
            let query = this.state.query;
        	query = _.omit(query, ['hotel', 'name', 'rfc', 'email'])

        	if (values.hotel && values.hotel.key)
        		query.hotel = {__type: 'Pointer', className: 'Hotel', objectId: values.hotel.key};

            if (values.name)
        		query.name = {$regex: '(?i)' + values.name};

        	if (values.rfc)
        		query.rfc = {$regex: '(?i)' + values.rfc};

        	if (values.email)
        		query.email = {$regex: '(?i)' + values.email};

        	if (this.props.app.user.type === 'recepcionista' || this.props.app.user.type === 'gerente') {
	            query.hotel = {$in: this.props.app.user.hotels}
	        }


        	this.setState({query: query});

            this.props.dispatch({type: 'client/filter', payload: {
            	where: query,
				skip: 0,
				limit: this.props.client.limit,
				count: 1,
				order: '-createdAt'
	    	}});
        })
    }


    render () {
    	const hotel_options = this.state.hotels.map(d => <Option key={d.objectId} label={d.name}>{d.name}</Option>)

	    return (
	        <div className="content-wrapper">
	            <section className="content-header">
	            	<h1>
	            		Clientes

	            		<div className="pull-right">
                            <Button type='primary'>
                                <Link to="/clients/new-client"><Icon name="plus" /> Agregar nuevo cliente</Link>
                            </Button>
                        </div>
	            	</h1>
	            </section>

	            <section className="content">
	            	<Collapse defaultActiveKey={['0']} className="marginBottom20">
					    <Panel header="Búsqueda" key="1">
					      	<Form onSubmit={this.search.bind(this)}>
                                <div className="row">
                                	{!this.state.currentHotel 
                                        ? <div className="col-md-3">
                                            <FormItem label="Hotel">
                                                {this.props.form.getFieldDecorator('hotel')(
                                                    <Select 
                                                        size='large'
                                                        mode="combobox"
                                                        onChange={this.handleSelectHotelChange.bind(this)}
                                                        filterOption={false}
                                                        labelInValue={true}
                                                        optionLabelProp='label'
                                                        placeholder="Elija el hotel"
                                                        >
                                                        {hotel_options}
                                                    </Select>
                                                )}
                                            </FormItem>
                                        </div>
                                        : ''
                                    }

                                	<div className="col-md-3">
                                        <FormItem label="Nombre">
                                            {this.props.form.getFieldDecorator('name')(<Input size='large' placeholder="Escriba el nombre" />)}
                                        </FormItem>
                                    </div>

                                    <div className="col-md-3">
                                        <FormItem label="RFC">
                                            {this.props.form.getFieldDecorator('rfc')(<Input size='large' placeholder="Escriba el RFC" />)}
                                        </FormItem>
                                    </div>

                                    <div className="col-md-3">
                                        <FormItem label="Correo electrónico">
                                            {this.props.form.getFieldDecorator('email')(<Input size='large' placeholder="Escriba el Email" />)}
                                        </FormItem>
                                    </div>
                                </div>

	                            <div className="row text-center paddingBottom30">
	                                <Button type='primary' onClick={this.search.bind(this)} loading={this.props.app.buttonLoading} className={'btn btn-primary btn-flat'}>
	                                    Buscar...
	                                </Button>
	                            </div>
		                    </Form>
					    </Panel>
					</Collapse>

	                <div className="box box-primary" style={{borderTopColor: this.props.app.currentHotel.color ? this.props.app.currentHotel.color : '#265f84'}}>
	                    <div className="box-body">
	                        <div className="row">
	                            <div className="col-xs-12">
	                            	<div className="table-responsive table">

		                            	<InfiniteScroll
										    padding={50}
									        throttle={100}
									        onScroll={() => this.loadMore()}>

		                                    <Table 
		                                    	dataSource={this.props.client.clients} 
		                                    	rowKey="objectId"
		                                    	size="middle" 
		                                    	loading={this.props.app.loadingTable} 
		                                    	pagination={false}>
		                                    	
		                                        <Column title="Nombre" key="name" render={(item) => (
		                                        	<span>
		                                        		<span className="color-primary">{item.name}</span><br />
		                                        		{item.emails.map(d => <small key={d}>{d}<br /></small>)}
		                                        	</span>
		                                        )} />
		                                        <Column title="Teléfono principal" dataIndex="phone1" key="phone1" />
		                                        <Column title="RFC" key="rfc" render={(item) => (
		                                        	<span style={{textTransform: 'uppercase'}}>{item.rfc}</span>
		                                        )} />
		                                        <Column title="Persona" dataIndex="type" key="type" />
		                                        <Column title="Localidad" dataIndex="locality" key="locality" />
		                                        {this.props.app.user
			                                        ? <Column title="Hotel" key="hotel" render={(item) => (
			                                        	<span>{item.hotel ? item.hotel.name : '-'}</span>
			                                        )} />
			                                        : ''
		                                    	}
		                                    	{this.props.app.user && this.props.app.user.type !== 'recepcionista'
                                                  ? <Column title="Creado por" key="createdBy" render={(item) => (
                                                        <span>{item.createdBy ? item.createdBy.name : '-'}</span>
                                                    )} />
                                                    : ''
                                                }
		                                        <Column title="Fecha registro" key="createdAt" render={(item) => (
		                                        	<span>{moment(item.createdAt).format('DD/MM/YYYY')}</span>
		                                        )}/>
		                                        <Column title="Acciones" key="action" width={130}
		                                            render={(item) => (
		                                                <span className="actions">
		                                                	<ButtonGroup>
			                                                    <Tooltip placement="bottom" title="Editar">
			                                                    	<Button>
			                                                    		<Link to={`/clients/details/${item.objectId}`}><Icon name="edit" /></Link>
			                                                        </Button>
			                                                    </Tooltip>

			                                                    <Tooltip placement="bottom" title="Solicitar factura">
			                                                    	<Button>
			                                                    		<Link to={`/invoices/new-invoice/${item.objectId}`}><Icon name="file-invoice" /></Link>
			                                                        </Button>
			                                                    </Tooltip>

			                                                    <Tooltip placement="bottom" title="Eliminar">
			                                                    	<Button>
			                                                    		<Link onClick={() => { this.delete_item(item) }}><Icon name="trash" /></Link>
			                                                        </Button>
			                                                    </Tooltip>
		                                                    </ButtonGroup>
		                                                </span>
		                                            )}
		                                        />
		                                    </Table>        
			                            </InfiniteScroll>
		                            </div>
	                            </div>
	                        </div>
	                    </div>
	                </div>
	            </section>
	        </div>
	    )
	}
}

export default connect(({client, app}) => ({client, app}))(Form.create()(Client))


// WEBPACK FOOTER //
// ./src/components/clients/index.js